export const PAGE_LIMIT = 25;

export const INIT_TAB = "main";

export const TEXTS = {
  HEADER: "TiVo Platforms, OEMs & Client Types",
  SUMMARY_TAB: "Summary",
  EDIT_TAB: "Edit",
  NAME_COL: "OEM / Client name",
  SLUG_COL: "Slug",
  OEM_CREATE_BTN: "Add new OEM",
  SEARCH_PLACEHOLDER: "Search for devices",
  MENU: {
    CLIENT_ADD: "Add new Client Type",
    CLIENT_DETAILS: "Client Type details",
    CLIENT_EDIT: "Edit Client Type",
    OEM_DETAILS: "OEM details",
    OEM_EDIT: "Edit OEM",
  },
};
